import { Link } from 'react-router';
import Functions from '../../../functions';
import iconFile from '../../assets/images/icon_binder.gif';
import type { ItemBinder } from '../../lib/ItemUtil';
import ListBase, { type ListBaseProps } from '../lib/ListBase';

class BinderList extends ListBase {
    constructor(props: ListBaseProps) {
        super(props);
        this.label = 'Binder';
        this.icon = iconFile;
    }

    renderBody() {
        const { lang } = this.props;
        const item = this.props.item as ItemBinder;
        return (
            <>
                <Link to={this.url}>{Functions.mlang(item.title, lang)}</Link>
                <br />
                {Functions.mlang(item.description, lang)}
            </>
        );
    }
}

export default BinderList;
